"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _core.makeStyles)({
  root: {
    fontFamily: _theme.default.typography.proxima.regular,
    padding: '40px',
    backgroundColor: _theme.default.palette.white,
    boxShadow: '0px 2px 4px 0 rgb(6 21 86 / 15%)',
    [_theme.default.breakpoints.down('lg')]: {
      padding: '30px 20px'
    }
  },
  option: {
    '& .MuiAccordionSummary-root': {
      padding: 0,
      minHeight: 0,
      maxHeight: '19px'
    },
    '& .MuiAccordionDetails-root': {
      padding: 0
    },
    '& .MuiPaper-elevation1': {
      boxShadow: 'none'
    },
    '& svg': {
      color: _theme.default.palette.primary.light
    },
    '& .MuiAccordionSummary-content': {
      margin: 0
    }
  },
  title: {
    fontFamily: _theme.default.typography.proxima.semiBold,
    color: _theme.default.palette.primary.main,
    fontSize: _theme.default.typography.pxToRem(16),
    lineHeight: '24px'
  },
  noStyleButton: {
    color: _theme.default.palette.primary.light,
    padding: '0',
    minWidth: 'auto',
    minHeight: 'auto',
    width: 'auto',
    height: 'auto',
    '&:hover': {
      background: 'none'
    },
    '&:focus': {
      outline: 0,
      border: 0
    },
    '& span': {
      fontSize: _theme.default.typography.pxToRem(16)
    }
  },
  wrapper: {
    display: 'none',
    marginTop: '10px'
  },
  expanded: {
    display: 'block'
  },
  subTitle: {
    display: 'block',
    color: _theme.default.palette.grayScale.dark,
    fontFamily: _theme.default.typography.proxima.semiBold,
    fontSize: _theme.default.typography.pxToRem(16),
    lineHeight: '24px',
    marginBottom: '30px'
  },
  separator: {
    width: '100%',
    borderBottom: "1px solid ".concat(_theme.default.palette.border),
    marginTop: '30px'
  },
  submitApplyBtn: {
    border: "1px solid ".concat(_theme.default.palette.primary.light),
    width: '183px',
    height: '50px',
    padding: '0',
    marginTop: '30px',
    '&.MuiButton-containedPrimary': {
      backgroundColor: 'transparent',
      color: _theme.default.palette.primary.light,
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    '&.Mui-disabled': {
      border: "1px solid ".concat(_theme.default.palette.grayScale.middleLight),
      color: _theme.default.palette.grayScale.middleLight
    }
  }
});
var _default = exports.default = useStyles;